module.exports = __webpack_public_path__ + "img/2010 winteressen 012.1762ab17.jpg";